export default "__VITE_PUBLIC_ASSET__fca216ca__"